'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var styles = {
  "TextContainer": "Polaris-TextContainer",
  "spacingTight": "Polaris-TextContainer--spacingTight",
  "spacingLoose": "Polaris-TextContainer--spacingLoose"
};

exports.default = styles;
